var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"input",attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }